import ProfileHeader from "../ProfileHeader";
import Message from "./Message";
import cloud from '../../../img/cloud.png'
import SubInformationConstructor from "./sub-information/SubInformationConstructor";
import OrganizationsList from "../OrganizationsList";
import Modal from "../Modal";
import clear from '../../../img/clear.png'
import Confirm from "../Confirm";
import API from "../../API";
import AdminTest from "./Admin-Test";
import {BACKUP, BASE_URL, MODERATOR_URL} from "../../../config";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import Instructions from "./Instructions";

export default function Admin() {
	const api = new API()
	const language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdOne: by.RoleIdOne;
	function componentOpenMessages() {
		return <button className='profile_block_fio-button'>{language.message}</button>
	}

	function componentOpenClear() {
		return (<button className='profile_block_fio-button' ><img alt="clear DB" src={clear}/></button>)
	}

	function componentOpenSubInformation() {
		return (<button className='profile_additional-button'>{language.additionalInformation}</button>)
	}

	function componentOpenTestsSettings() {
		return (<button className='profile_additional-button'>{language.tests}</button>)
	}
	function componentOpenInstructionsSitting() {
		return (<button className='profile_additional-button'>{language.instructions}</button>)
	}
	function clearDB() {
		api.clearDataBase().then(result => {
      if(!result) {return}
				console.log(result)
    })
	}

	const messageList = <Modal key="1" componentOpen={componentOpenMessages} component={Message}/>
	const clearDataBase = <Modal key="2" additional={{funcYes: clearDB, text: "Вы уверенны что хотите очистить базу данных?"}} component={Confirm} componentOpen={componentOpenClear}/>
	const getBackup = <button key="3" className='profile_block_fio-button' onClick={e=>window.open(BASE_URL + BACKUP)}><img src={cloud} alt="copy"/></button>
	const creatorPage = <button  key="4" className='profile_block_fio-button' onClick={()=>{window.location.href=MODERATOR_URL}} >{language.editor}</button>

	const subInformationConstructor = <Modal key="4" component={SubInformationConstructor} componentOpen={componentOpenSubInformation}/>
	const testsSettings = <Modal key="5" component={AdminTest} componentOpen={componentOpenTestsSettings}/>
	const instructionsSittings =<Modal key={6} component={Instructions} componentOpen={componentOpenInstructionsSitting}/>
	return (
		<div className='profile_content'>
				<div className='profile_block_cont'>
					<ProfileHeader elements={[messageList, clearDataBase, getBackup,creatorPage]} additionals={[subInformationConstructor, testsSettings,instructionsSittings]}/>
					<OrganizationsList/>
				</div>
			</div>
	)
}